// src/components/Settings/SettingsComponents/LargeLanguageModel.tsx

import React from "react";
import ViewModel from "./LargeLanguageModelComponents/ViewModel";

const LargeLanguageModel: React.FC = () => {
  return (
    <div className="mx-auto w-full max-w-screen-lg divide-y divide-gray-200 rounded-xl bg-white p-2">
      <ViewModel />
    </div>
  );
};

export default LargeLanguageModel;